import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import BalanceIcon from '@mui/icons-material/Balance';
import CancelIcon from '@mui/icons-material/Cancel';
export function CostSection() {
  const costs = [{
    without: 'Seguir probando dietas de 3 días',
    cost: 'Años de tu vida en modo "volver a empezar"'
  }, {
    without: 'Suplementos sin protocolo base',
    cost: 'Plata gastada sin atacar la causa raíz'
  }, {
    without: 'Información suelta de internet',
    cost: 'Más confusión, más contradicción, menos acción'
  }, {
    without: 'Sin plan de comidas claro',
    cost: 'Semanas enteras saboteadas por no saber qué comer'
  }, {
    without: 'Sin sistema de compras',
    cost: 'Volvés del super con lo que te frena'
  }, {
    without: 'Sin identificar tus errores',
    cost: 'Seguís cometiendo los mismos 7 errores sin saberlo'
  }];
  return <SectionWrapper className="bg-white" data-id="element-18">
      <div className="text-center mb-12" data-id="element-19">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-100 text-gray-600 mb-4" data-id="element-20">
          <BalanceIcon data-id="element-21" />
        </div>
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-22">
          ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden mb-12" data-id="element-23">
        <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-24">
          <div className="bg-red-50 p-6 md:p-8 border-b md:border-b-0 md:border-r border-red-100" data-id="element-25">
            <h3 className="font-bold text-red-800 text-lg mb-6 flex items-center" data-id="element-26">
              <CancelIcon className="mr-2" data-id="element-27" /> Sin REINICIO INTERNO
            </h3>
            <ul className="space-y-4" data-id="element-28">
              {costs.map((item, i) => <li key={i} className="text-gray-700 font-medium text-sm md:text-base border-b border-red-100/50 pb-3 last:border-0" data-id="element-29">
                  {item.without}
                </li>)}
            </ul>
          </div>
          <div className="bg-gray-900 p-6 md:p-8" data-id="element-30">
            <h3 className="font-bold text-white text-lg mb-6" data-id="element-31">Costo real</h3>
            <ul className="space-y-4" data-id="element-32">
              {costs.map((item, i) => <li key={i} className="text-gray-300 font-medium text-sm md:text-base border-b border-gray-800 pb-3 last:border-0" data-id="element-33">
                  {item.cost}
                </li>)}
            </ul>
          </div>
        </div>
      </div>

      <div className="text-center max-w-2xl mx-auto" data-id="element-34">
        <p className="text-xl font-bold text-gray-900 mb-4" data-id="element-35">
          El próximo lunes puede ser diferente.
        </p>
        <p className="font-serif text-2xl md:text-3xl text-primary font-bold italic" data-id="element-36">
          "Tu cuerpo no está roto. Solo necesita el sistema correcto." 🌿
        </p>
      </div>
    </SectionWrapper>;
}